import React, { useEffect } from "react";
import { DialogMessage } from "utils/helpers/DialogMessage";
import { testId } from "tests/testIdStrings";
import { FormattedTypography } from "utils/helpers/FormattedTypography";
import { iconLockOpen } from "theme/icons";
import { Stack } from "@mui/material";
import { useFetch } from "hooks/useFetch";
import { API_URL_BO_EDUCATION } from "utils/constants";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { educationState, educationStateFinalTestUnlocked } from "state/educationState";

type Props = {
  open: boolean;
  close: () => void;
};

export const FinalTestDialog: React.FC<Props> = ({ open, close }) => {
  const educationIdentifier = useRecoilValue(educationState)?.identifier;
  const finalTestUnlocked = useSetRecoilState(educationStateFinalTestUnlocked);
  const refreshEducations = () => finalTestUnlocked((n: number) => n + 1);

  const { patch, json } = useFetch();

  useEffect(() => {
    if (!json) return;

    refreshEducations();
    close();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [json]);

  const handleUnlock = () => {
    patch(API_URL_BO_EDUCATION + "final-test-is-unlocked", {
      finalTestIsUnlocked: true,
      educationIdentifier: educationIdentifier!,
    });
  };

  return (
    <DialogMessage
      title="test.final.dialog.title"
      open={open}
      close={close}
      primaryButtonText="test.final.dialog.button"
      primaryButtonColor="error"
      primaryButtonIcon={iconLockOpen}
      primaryButtonAction={handleUnlock}
      dataTestIdString={testId.listItem.test.common.unlock}
    >
      <Stack spacing={2}>
        <FormattedTypography id="test.final.dialog.body-1" />
        <FormattedTypography id="test.final.dialog.body-2" />
        <FormattedTypography id="test.final.dialog.body-3" />
      </Stack>
    </DialogMessage>
  );
};
